export enum StatusKeysEnum {
  PAST = 'past',
  CURRENT = 'current',
  FUTURE = 'future',
}

export const StatusKeys = StatusKeysEnum;

export interface PhenologicalInformation {
  startDate: string;
  endDate: string;
  phenologicalPhaseCommonId: string;
  status: StatusKeysEnum;
}

export interface PhenologicalPhase {
  companyId: number;
  id: number;
  crop: { id: number };
  dateCreated: string;
  lastUpdate: string;
  deleted: boolean;
  phases: PhenologicalInformation[];
}
